<ngx-smart-modal #reportModal identifier="reportModal">
	<div class="container-capped-sm p-3" *ngIf="!user">
		<app-login [inline]="true" [show-name-input]="true" intro="برای ثبت گزارش تخلف به شماره موبایل شما نیاز داریم.">
		</app-login>
	</div>
	<div class="p-3" *ngIf="user">
		<h4>
			<i class="fa fa-flag ml-1 fs-xl"></i>
			گزارش مشکل آگهی
		</h4>
		<div class="mb-3">
			از بین گزینه‌های زیر کدوم به مشکلی که پیدا کردی نزدیک‌تره؟
		</div>
		<div>
			<label *ngFor="let reason of reportReasons">
				<input type="radio" name="report-reason" [checked]="reason == reportReason" (change)="reportReason=reason">
				{{reason}}
			</label>
		</div>
		<div class="text-left py-2">
			<button [disabled]="!reportReason" (confirm)="report()"
				message="گزارش شما بررسی و در صورت مغایرت با قوانین این آگهی حذف خواهد شد." class="btn btn-primary">
				<i class="fa fa-flag ml-1"></i>
				ثبت گزارش
			</button>
		</div>
	</div>
</ngx-smart-modal>